import Vue from 'vue'
import VueI18n from 'vue-i18n'

import { en } from '@/lang/en'
import { ro } from '@/lang/ro'
import { dates, numbers } from '@/lang/ro/format'

Vue.use(VueI18n)

const messages = {
  en: en,
  ro: ro
}

const dateTimeFormats = {
  en: {},
  ro: dates
}

const numberFormats = {
  en: {},
  ro: numbers
}

export const getLocale = (): string => {
  // const cookieLanguage = getLanguage()
  // if (cookieLanguage) {
  //   return cookieLanguage
  // }

  return 'ro'

  const language = navigator.language.toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }

  // Default language is english
  return 'en'
}

const i18n = new VueI18n({
  locale: getLocale(),
  // eslint-disable-next-line
  // @ts-ignore
  dateTimeFormats,
  numberFormats,
  messages
})

export default i18n
